import { render, staticRenderFns } from "./addminus.vue?vue&type=template&id=598c5d87&scoped=true"
import script from "./addminus.vue?vue&type=script&lang=js"
export * from "./addminus.vue?vue&type=script&lang=js"
import style0 from "./addminus.vue?vue&type=style&index=0&id=598c5d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598c5d87",
  null
  
)

export default component.exports